import assert from 'assert';
import {IS_CLIENT_SIDE} from '../utils/constants';

/**
 * 카카오 SDK를 동적으로 import 하는 함수
 *
 * 브라우저에서만 호출해야 합니다.
 */
export async function importKakaoSdk() {
  assert(IS_CLIENT_SIDE);

  if (!Object.prototype.hasOwnProperty.call(window, 'Kakao')) {
    // @ts-ignore
    await import('../../../../public/public/js/kakao.min.js');
  }
  if (!(window as any).Kakao.isInitialized()) {
    (window as any).Kakao.init('49bbb48c5fdb0199e5da1b89de359484');
  }
}
